<ng-container thr-parent-form>
    <div class="container">
        <div class="row">
            <div class="col-12 col-sm-auto mb-4 mb-sm-0 mr-sm-4">
                <mat-slide-toggle name="pnpIsSpanish" color="blue-gray" labelPosition="before" [disabled]="client.disabled" [(ngModel)]="client.isSpanish">
                    {{ 'form.you-are-spanish' | translate }}
                </mat-slide-toggle>
            </div>
            <div class="col-12 col-sm-auto">
                <mat-slide-toggle name="pnpIsResident" color="blue-gray" labelPosition="before" [disabled]="client.disabled" [(ngModel)]="client.isResident">
                    {{ 'form.you-are-resident' | translate }}
                </mat-slide-toggle>
            </div>
        </div>

        <hr class="mt-4 mb-3" />

        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select name="pnpDocumentType" [placeholder]="'form.document' | translate" [disabled]="client.disabled" [(ngModel)]="client.docType">
                        <ng-template ngFor let-type [ngForOf]="client.allowedDocTypes">
                            <mat-option [value]="type">{{ 'form.document-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6 col-lg-3">
                <ng-container [ngSwitch]="client.docType">
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.DNI">
                        <mat-label>{{ 'form.document-types.DN' | translate }}</mat-label>
                        <input name="pnpDocument" matInput [placeholder]="'form.hints.dni' | translate" required minlength="9" maxlength="10" dni noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.DNI" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('dni') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIF">
                        <mat-label>{{ 'form.document-types.NF' | translate }}</mat-label>
                        <input name="pnpDocument" matInput [placeholder]="'form.hints.nif' | translate" required minlength="9" maxlength="15" nif noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.NIF" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('nif') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE">
                        <mat-label>{{ 'form.document-types.NR' | translate }}</mat-label>
                        <input name="pnpDocument" matInput [placeholder]="'form.hints.nie' | translate" required minlength="9" maxlength="15" nie noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.NIE" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" #documentCtrl="ngModel" />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.NIE_NOT_RESIDENT">
                        <mat-label>{{ 'form.document-types.NN' | translate }}</mat-label>
                        <input name="pnpDocument" matInput [placeholder]="'form.hints.nie' | translate" required maxlength="15" nie noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.NIE_NOT_RESIDENT" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('nie') && !documentCtrl.hasError('required')">
                            {{ 'form.validation.invalid.document' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT">
                        <input name="pnpDocument" matInput [placeholder]="'form.document-types.PN' | translate" required maxlength="15" noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.PASSPORT" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PASSPORT_LATIN">
                        <input name="pnpDocument" matInput [placeholder]="'form.document-types.PL' | translate" required maxlength="15" noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.PASSPORT_LATIN" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchCase="DocumentType.PERMISSION">
                        <input name="pnpDocument" matInput [placeholder]="'form.document-types.PR' | translate" required maxlength="15" noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.PERMISSION" existsInContract
                            [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                    <mat-form-field class="full-width mb-3 mb-sm-4" *ngSwitchDefault>
                        <input name="pnpDocument" matInput [placeholder]="'form.document-types.TR' | translate" required maxlength="15" noWhitespaces [clientExists]="!isClientPortal && isFirst" [isClientNatural]="!isClientPortal && !isFirst" [docType]="DocumentType.IDENTIFICATION_CARD_NOT_RESIDENT"
                            existsInContract [clientId]="client.id" [field]="'docId'" [otherValue]="pupil ? pupil.docId : null" [disabled]="client.disabled" [(ngModel)]="client.docId" (blur)="onDocumentBlur()" [ngModelOptions]="{ updateOn: 'blur' }" #documentCtrl="ngModel"
                        />
                        <mat-error *ngIf="documentCtrl.hasError('noWhitespaces')">
                            {{ 'form.validation.no-whitespaces' | translate }}
                        </mat-error>
                        <mat-error *ngIf="cannotBeLegal">
                            {{ 'form.validation.cannot-be-legal-person' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists' | translate }}
                        </mat-error>
                        <mat-error *ngIf="
                                documentCtrl.hasError('clientExists') &&
                                !documentCtrl.getError('owner') &&
                                !documentCtrl.hasError('required')
                            ">
                            {{ 'form.validation.client-exists-other-agent' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('isClientNatural')">
                            {{ 'form.validation.is-client-natural' | translate }}
                        </mat-error>
                        <mat-error *ngIf="documentCtrl.hasError('existsInContract')">
                            {{ 'form.validation.client-exists-in-contract' | translate }}
                        </mat-error>
                        <mat-error *ngIf="!cannotBeLegal && documentCtrl.hasError('required')">
                            {{ 'form.validation.required' | translate }}
                        </mat-error>
                    </mat-form-field>
                </ng-container>
            </div>
            <div class="col-12 col-sm-6 col-lg-3">
                <!-- TODO: BUG with required dynamic in child form component https://github.com/angular/angular/issues/23657 -->
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="!client.docExpirationDatePermanent">
                    <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                    <input name="pnpDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" required maxlength="10" [disabled]="client.disabled" [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel"
                    />
                    <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                    <mat-datepicker #documentPicker [disabled]="client.disabled"></mat-datepicker>
                    <mat-error *ngIf="!documentExpirationCtrl.valid">
                        {{ 'form.validation.expired-document-date' | translate }}
                    </mat-error>
                </mat-form-field>
                <mat-form-field class="full-width mb-3 mb-sm-4" *ngIf="client.docExpirationDatePermanent">
                    <mat-label>{{ 'form.expired-document-date.' + client.docType | translate }}</mat-label>
                    <input name="pnpDocumentExpiration" matInput [min]="today" [matDatepicker]="documentPicker" disabled [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.docExpirationDate" #documentExpirationCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="documentPicker"></mat-datepicker-toggle>
                    <mat-datepicker #documentPicker disabled></mat-datepicker>
                    <mat-error *ngIf="!documentExpirationCtrl.valid">
                        {{ 'form.validation.expired-document-date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6 col-lg-2 mb-3 mb-sm-0 mt-sm-2 mt-md-3">
                <mat-checkbox name="pnpPermanentValidity" [disabled]="client.disabled" [(ngModel)]="client.docExpirationDatePermanent">
                    {{ 'form.permanent-validity' | translate }}
                </mat-checkbox>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="pnpName" matInput [placeholder]="'form.name' | translate" required maxlength="20" [disabled]="client.disabled" [(ngModel)]="client.name" #nameCtrl="ngModel" />
                    <mat-error *ngIf="nameCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="pnpSurname" matInput [placeholder]="'form.surname' | translate" required maxlength="60" [disabled]="client.disabled" [(ngModel)]="client.surname" #surnameCtrl="ngModel" />
                    <mat-error *ngIf="surnameCtrl.hasError('required')">
                        {{ 'form.validation.required' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select
                        name="pnpGenderType"
                        [placeholder]="'form.gender' | translate"
                        [disabled]="client.disabled"
                        [(ngModel)]="client.gender"
                        required
                        #genderCtrl="ngModel"
                    >
                        <ng-template ngFor let-type [ngForOf]="client.allowedGenderTypes">
                            <mat-option [value]="type">{{ 'form.gender-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="genderCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-select
                        name="pnpMaritalStatusType"
                        [placeholder]="'form.marital-status' | translate"
                        [disabled]="client.disabled"
                        [(ngModel)]="client.maritalStatus"
                        required
                        #maritalStatusCtrl="ngModel"
                    >
                        <ng-template ngFor let-type [ngForOf]="client.allowedMaritalStatusTypes">
                            <mat-option [value]="type">{{ 'form.marital-status-types.' + type | translate }}</mat-option>
                        </ng-template>
                    </mat-select>
                    <mat-error *ngIf="maritalStatusCtrl.hasError('required')">
                        {{ 'form.validation.required'|translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-md-6">
                <ng-container *ngIf="!isClientPortal">
                    <mat-checkbox name="pnpNotPhone" [(ngModel)]="client.phoneExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elsePhone">
                        {{ 'form.not-phone' | translate }}
                    </mat-checkbox>
                    <ng-template #elsePhone>
                        <mat-checkbox name="pnpNotPhone" [disabled]="true" [(ngModel)]="client.phoneExonerate">
                            {{ 'form.not-phone' | translate }}
                        </mat-checkbox>
                    </ng-template>
                </ng-container>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pnpPhone" matInput [placeholder]="'form.phone' | translate" required minlength="9" pattern="[\d\+]+" existsInContract [clientId]="client.id" [field]="'phone'" [otherValue]="pupil ? pupil.phone : null" [phoneExists]="!isClientPortal" [disabled]="client.phoneExonerate || client.disabled"
                                [(ngModel)]="client.phone" #phoneCtrl="ngModel" />
                            <mat-error *ngIf="
                                    (phoneCtrl.hasError('minlength') || phoneCtrl.hasError('pattern')) && !phoneCtrl.hasError('required')
                                ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('phoneExists') && !phoneCtrl.hasError('required')">
                                {{ 'form.validation.phone-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('existsInContract')">
                                {{ 'form.validation.phone-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pnpPhoneConfirm" matInput [placeholder]="'form.phone-confirm' | translate" required minlength="9" pattern="[\d\+]+" [equalTo]="phoneCtrl" [disabled]="client.phoneExonerate || client.disabled" [(ngModel)]="client.phoneConfirm" #phoneConfirmCtrl="ngModel"
                            />
                            <mat-error *ngIf="
                                    (phoneConfirmCtrl.hasError('minlength') || phoneConfirmCtrl.hasError('pattern')) &&
                                    !phoneConfirmCtrl.hasError('required')
                                ">
                                {{ 'form.validation.invalid.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    phoneConfirmCtrl.hasError('equalTo') &&
                                    !phoneConfirmCtrl.hasError('minlength') &&
                                    !phoneConfirmCtrl.hasError('pattern') &&
                                    !phoneConfirmCtrl.hasError('required')
                                ">
                                {{ 'form.validation.equalTo.phone' | translate }}
                            </mat-error>
                            <mat-error *ngIf="phoneConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>

            <div class="col-12 col-md-6">
                <ng-container *ngIf="!isClientPortal">
                    <mat-checkbox name="pnpNotEmail" [(ngModel)]="client.emailExonerate" (ngModelChange)="onExonerate()" *ngIf="!client.disabled; else elseEmail">
                        {{ 'form.not-email' | translate }}
                    </mat-checkbox>
                    <ng-template #elseEmail>
                        <mat-checkbox name="pnpNotEmail" [disabled]="true" [(ngModel)]="client.emailExonerate">
                            {{ 'form.not-email' | translate }}
                        </mat-checkbox>
                    </ng-template>
                </ng-container>
                <div class="row">
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pnpEmail" matInput [placeholder]="'form.email' | translate" required emailWithDot existsInContract [clientId]="client.id" [field]="'email'" [otherValue]="pupil ? pupil.email : null" [emailExists]="!isClientPortal" [disabled]="client.emailExonerate || client.disabled"
                                [(ngModel)]="client.email" #emailCtrl="ngModel" />
                            <mat-error *ngIf="emailCtrl.hasError('email') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('emailExists') && !emailCtrl.hasError('required')">
                                {{ 'form.validation.email-exists' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('existsInContract')">
                                {{ 'form.validation.email-exists-in-contract' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-12 col-sm-6 col-md-12">
                        <mat-form-field class="full-width mb-3 mb-sm-4">
                            <input name="pnpEmailConfirm" matInput [placeholder]="'form.email-confirm' | translate" required emailWithDot [equalTo]="emailCtrl" [disabled]="client.emailExonerate || client.disabled" [(ngModel)]="client.emailConfirm" #emailConfirmCtrl="ngModel" />
                            <mat-error *ngIf="emailConfirmCtrl.hasError('email') && !emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.invalid.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="
                                    emailConfirmCtrl.hasError('equalTo') &&
                                    !emailConfirmCtrl.hasError('email') &&
                                    !emailConfirmCtrl.hasError('required')
                                ">
                                {{ 'form.validation.equalTo.email' | translate }}
                            </mat-error>
                            <mat-error *ngIf="emailConfirmCtrl.hasError('required')">
                                {{ 'form.validation.required' | translate }}
                            </mat-error>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12 col-sm-6 col-lg-4">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <input name="pnpLandline" matInput [placeholder]="'form.telephone' | translate" minlength="9" pattern="[\d\+]+" [disabled]="client.disabled" [(ngModel)]="client.landLine" #landLineCtrl="ngModel" />
                    <mat-error *ngIf="landLineCtrl.hasError('minlength') || landLineCtrl.hasError('pattern')">
                        {{ 'form.validation.invalid.phone' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>

            <div class="col-12 col-sm-6 col-lg-4" *ngIf="!client.disabled">
                <mat-form-field class="full-width mb-3 mb-sm-4">
                    <mat-label>{{ 'form.birth-date' | translate }}</mat-label>
                    <input name="pnpBirthDate" matInput [max]="today" [min]="hundredYears" [matDatepicker]="birthDatePicker" required maxlength="10" ofLegalAge [placeholder]="'form.hints.date' | translate" [(ngModel)]="client.birthDate" #birthDateCtrl="ngModel" />
                    <mat-datepicker-toggle matSuffix [for]="birthDatePicker"></mat-datepicker-toggle>
                    <mat-datepicker #birthDatePicker></mat-datepicker>
                    <mat-error *ngIf="birthDateCtrl.hasError('ofLegalAge')">
                        {{ 'form.validation.of-legal-age' | translate }}
                    </mat-error>
                    <mat-error *ngIf="!birthDateCtrl.hasError('ofLegalAge') && !birthDateCtrl.valid">
                        {{ 'form.validation.invalid.date' | translate }}
                    </mat-error>
                </mat-form-field>
            </div>
        </div>

        <div class="row">
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="pnpLegal" required [disabled]="client.disabled" [(ngModel)]="client.acceptLegal">
                    <span>
                        {{ 'form.accept-legal' | translate }}
                        <a href="javascript:void(0)" (click)="openDialog()">{{ 'form.info-rgpd' | translate }} </a>
                        <span [innerHTML]="'form.and-accept-privacy-policy' | translate"></span>
                    </span>
                    <span class="d-block text-error" *ngIf="!client.acceptLegal">
                        {{ 'form.validation.accept-legal' | translate }}
                    </span>
                </mat-checkbox>
            </div>
            <div class="col-12 mb-2 mb-sm-3">
                <mat-checkbox name="pnpMarketing" [disabled]="client.disabled" [(ngModel)]="client.acceptMarketing">
                    <strong [innerHTML]="'form.accept-marketing' | translate"></strong>:
                    <span [innerHTML]="'form.accept-marketing-text' | translate"></span>
                </mat-checkbox>
            </div>
        </div>

        <div class="row" *ngIf="(client.phoneExonerate || client.emailExonerate) && !client.disabled">
            <div class="col-12">
                <p class="mat-caption text-error font-italic">
                    {{ 'form.validation.exonerate' | translate }}
                </p>
            </div>
        </div>
    </div>
</ng-container>
